import React, { Component } from "react";
import Education from "./Education.css";

class EducationComponent extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const showDetailCards = cardData => {
      if (cardData.length > 0) {
        return cardData[0].data.map((subCategory, index) => {
          return (
            subCategory.title &&
            subCategory.content && (
              <div key={index} className="detailBlocks">
                <h4> {subCategory.title} </h4>
                {typeof subCategory.content === "string" ? (
                  <p className="educationSubCategory">{subCategory.content}</p>
                ) : (
                  Array.from(subCategory.content).map((item, index) => {
                    return (
                      <li key={index}>
                        <a href={item.url} target="_blank">
                          {item.title}
                        </a>
                      </li>
                    );
                  })
                )}
              </div>
            )
          );
        });
      } else {
        return <p>No Data</p>;
      }
    };

    return <div className="accordion educationDetails">{showDetailCards(this.props.data)}</div>;
  }
}

export default EducationComponent;



// WEBPACK FOOTER //
// ./src/components/features/Education.js